import { Channel as ChannelTypes } from '@/constants/user/channels'

export default class Channel {
  type: ChannelTypes
  value: string
  isVisible: boolean
  customerType?: number

  constructor(props: Partial<Channel>) {
    Object.assign(this, props)
  }

  static fromServer(data: LX.Channel) {
    return new Channel({
      ...data,
      customerType: data.customer_type,
      isVisible: Boolean(data.is_visible),
    })
  }

  toServer() {
    return {
      type: this.type,
      value: this.value.trim(),
      profile_type: this.customerType,
      is_visible: Number(this.isVisible),
    }
  }
}
